var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "customcheckerboard-main-views-wrapper"
  }, [_c('base-spinner', {
    attrs: {
      "set-spinner-default": true,
      "classes": "spinner",
      "position": "absolute"
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }]
  }, [_c('checkerboard-fabric-canvas', {
    key: _vm.fabricCanvasComponentKey,
    ref: "canvasImage",
    attrs: {
      "tileConfig": _vm.tileConfig,
      "color1": _vm.canvasConfig.color1,
      "color2": _vm.canvasConfig.color2
    }
  }), _vm._l(_vm.components, function (component) {
    return _c('img', {
      key: "warpImage".concat(component),
      ref: "warpImage".concat(component),
      refInFor: true
    });
  })], 2), _c(_vm.activeView, _vm._b({
    tag: "component",
    attrs: {
      "canvasLoaded": _vm.isCanvasLoaded
    },
    on: {
      "sizeSelected": _vm.sizeSelected,
      "setCanvasLoaded": _vm.setCanvasLoaded,
      "generateCanvas": _vm.generateCanvas
    }
  }, 'component', _vm.$attrs, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }